import { CAT_VARIATIONS } from 'App/utils/Collections';
import { FT_SINGLE, FT_DATE, FT_CHECKBOX, FT_AUTOCOMPLETE, FT_CONDITION_GROUP, FT_LIST } from '../FilterTypes';
import { loadLocations, loadFeatures } from './loaders';
import { SUB_PRODUCTS_VAPING_DEV_ID } from '@/app/utils/Collections';
import { productTypesLoader, loadCompetitors } from './loaders';
import { i18n } from 'App/plugins/i18n';

const SPLITTABLE_HINT = 'You can type multiple values separated by comma, semicolon, or space.';

const HEATED_STICKS_ID = 123;
const ORAL_POUCHES_ID = 159;

export const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
  files: {
    name: 'Files',
    groupOrderIndex: 2,
  },
  competitors: {
    name: 'Competitors',
    groupOrderIndex: 3,
  },
  features: {
    name: 'Features',
    groupOrderIndex: 99,
    isFeature: true,
    sm: 12,
    md: 12,
    lg: 12,
    xLg: 12,
  },
};

export default {
  category: CAT_VARIATIONS,
  resources: [
    {
      name: 'features',
      loader: async () =>
        await loadFeatures(
          groups.features,
          {
            'categories.id': SUB_PRODUCTS_VAPING_DEV_ID,
            applicableEntities: 'variation',
            locale: i18n.locale,
          },
          { favoriteConditionGroup: true }
        ),
    },
  ],
  filters: [
    {
      id: 'product.id',
      label: 'Product ID',
      type: FT_SINGLE,
      group: groups.general,
      splittable: true,
      hint: SPLITTABLE_HINT,
    },
    {
      id: 'id',
      label: 'Variation ID',
      type: FT_SINGLE,
      group: groups.general,
      splittable: true,
      hint: SPLITTABLE_HINT,
    },
    {
      id: 'nbFirstSubmissionDate',
      label: 'NB First Submission Date',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'nbLastSubmissionDate',
      label: 'NB Last Submission Date',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'nbLaunchDate',
      label: 'NB Launch Date',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'startedOn',
      label: 'Started on',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'stoppedOn',
      label: 'Stopped on',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'exists[files]',
      label: 'Contains Files',
      fieldConf: {
        label: 'Show items with files',
      },
      group: groups.files,
      type: FT_CHECKBOX,
      defaultValue: () => true,
    },
    {
      id: 'country.id',
      label: 'Countries',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: loadLocations,
        items: loadLocations,
      },
    },
    {
      id: 'and_group_or_product.types',
      propertyName: 'and_group_or_product.types',
      label: 'Product Type',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose type',
      fieldConf: {
        items: () => productTypesLoader({ id: [HEATED_STICKS_ID, ORAL_POUCHES_ID] }),
      },
      children: ['and_group_or_product.types__comp'],
    },
    {
      id: 'status',
      label: 'Status',
      group: groups.general,
      type: FT_LIST,
      multiValues: false,
      isSingle: true,
      getListItems: () => [
        { id: 'true', name: 'ON' },
        { id: 'false', name: 'OFF' },
      ],
    },
    {
      id: 'and_group_or_product.types__comp',
      propertyName: 'and_group_or_product.types',
      label: 'Names',
      group: groups.competitors,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose type',
      fieldConf: {
        items: loadCompetitors,
      },
      parent: 'and_group_or_product.types',
      childOptions: {
        childItems: loadCompetitors,
      },
    },
    {
      id: 'manufacturingCountry.id',
      label: 'Country of manufacture',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: loadLocations,
        items: loadLocations,
      },
    },
    {
      id: 'nbProductId',
      label: 'NB Product ID',
      type: FT_SINGLE,
      group: groups.general,
      splittable: true,
      hint: SPLITTABLE_HINT,
    },
  ],
  searchBarProp: 'complex_name',
};
